import { css } from '@emotion/react'
import { Positions } from './types'
import { cross, dimensionFromPosition } from './dimensions'
import { CSSProperties } from 'react'
import { StyleModifier } from 'components/styles/primitives/modifiers/types'

export const PositionedFrom = (position: Positions) =>
	css({ [position]: 0, position: 'absolute', [cross(dimensionFromPosition(position))]: '100%' })

type PositionModProps = Pick<CSSProperties, Positions> & { position?: CSSProperties['position'] }

export const PositionModFn: StyleModifier<PositionModProps> = ({ position, top, left, right, bottom }) =>
	css({ top, left, bottom, right, position })

export const PositionMods = {
	...PositionModFn,
	Absolute: PositionModFn({ position: 'absolute' }),
	Relative: PositionModFn({ position: 'relative' }),
	Fixed: PositionModFn({ position: 'fixed' })
}
